import { flow } from 'fp-ts/function';
import { every, get, has } from 'lodash/fp';

import { MultiCurrencyAmount } from '@mews-distributor/common';

import { getPricingHash, GetPricingHashOptions } from './getPricingHash';
import { Pricing, PricingRate, PricingValue } from './types';

interface PricingOptions extends GetPricingHashOptions {
    pricing: Pricing;
}

const getPricingValue = ({ pricing, ...pricingHashOptions }: PricingOptions) =>
    pricing[getPricingHash(pricingHashOptions)] ?? {};

interface PricingRateOptions extends PricingOptions {
    rateId: string;
}

const getPricingRate = ({ rateId, ...options }: PricingRateOptions) =>
    flow<[PricingOptions], PricingValue, PricingRate>(getPricingValue, get(['rates', rateId]))(options);

export const getPricingRateTotalPrice = flow<[PricingRateOptions], PricingRate, MultiCurrencyAmount>(
    getPricingRate,
    get(['price', 'totalAmount'])
);

export const hasPricingCurrencyPrices = (rateId: string, currencyCode: string, pricingValue: PricingValue) =>
    has(['rates', rateId, 'price', 'totalAmount', currencyCode], pricingValue);

const haveAllRatesCurrencyCode = (currencyCode: string) => every(has(['price', 'totalAmount', currencyCode]));
export const haveAllPricingRatesCurrencyCode = (currencyCode: string, pricing: PricingValue) =>
    flow(get('rates'), haveAllRatesCurrencyCode(currencyCode))(pricing);
